<script>
import auctionTimer from "../components/auctionTimer";

export default {
  name: "host-toolbar",
  components: {
    auctionTimer,
  },

  data: function() {
    return {};
  },
  methods: {
    async onExtend(seconds) {
      await this.$store.dispatch("getRequest", { controller: "auction", method: `ExtendAuction/${this.auctionId}`, parameters: { seconds: seconds } });
    },
    async onEndAuction(seconds) {
      var shouldStartAuction = confirm("Are you sure you wish to terminate this auction early? Please ensure all participants are finished bidding before proceeding.");
      if (shouldStartAuction) {
        await this.$store.dispatch("getRequest", { controller: "auction", method: `StopAuction/${this.auctionId}` });
      }
    },
    async onStartAuctionNowClick() {
      this.$store.commit("toggleAuctionTriggerModal", true);
    },
    getRepVesselsClass: function() {
      if (this.presentVesselsCount == this.activeAuction.bids.length) {
        return "all-present";
      } else if (this.presentVesselsCount < this.activeAuction.bids.length && this.presentVesselsCount > 0) {
        return "some-present";
      } else {
        return "none-present";
      }
    },
    getEstimatedDailyFuelCost(b) {
      var ecoSpeedConsumption = b.offer.Vessel.mac_fue_economicSpeedFuel;
      var rate = this.activeAuction.fuelCost;
      var unit = this.activeAuction.fuelUnit;
      return getEstimatedDailyFuelCost(ecoSpeedConsumption, rate, unit);
    },
  },
  computed: {
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    auctionTimePassed: function() {
      return this.$store.state.auctionTimePassed;
    },
    activeAuctionStatus: function() {
      return this.$store.state.activeAuction.status;
    },
    activeAuction: function() {
      return this.$store.state.activeAuction;
    },
    lowestBid: function() {
      return this.$store.state.activeAuction
        ? this.$store.state.activeAuction.bids.filter(function(x) {
            return x.lowestBid;
          })
        : null;
    },
    lowestBidVessels: function() {
      if (!this.lowestBid || this.lowestBid.length == 0) {
        return null;
      }
      return this.lowestBid
        .map(function(x) {
          return x.vesselName;
        })
        .join(", ");
    },
    lowestBidRate: function() {
      if (!this.lowestBid || this.lowestBid.length == 0) {
        return null;
      }
      return this.activeAuction.includeFuelCost
        ? `${
            (this.lowestBid[0].currentRate + this.getEstimatedDailyFuelCost(this.lowestBid[0]))
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")
              .split(".")[0]
          } ${this.currency}`
        : `${
            this.lowestBid[0].currentRate
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")
              .split(".")[0]
          } ${this.currency}`;
    },
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    activeBidders: function() {
      var result = this.$store.state.activeAuction.activeBidders ? Object.keys(this.$store.state.activeAuction.activeBidders).length : 0;
      return result;
    },
    presentVesselsCount: function() {
      if (this.$store.state.activeAuction.activeBidders) {
        var allBids = [];
        var activeBidders = this.$store.state.activeAuction.activeBidders;
        for (var i = 0; i < activeBidders.length; i++) {
          allBids.push(...activeBidders[i].associatedBids);
        }
        var uniqueBids = allBids.filter(function(item, pos) {
          return allBids.indexOf(item) == pos;
        });
        return uniqueBids.length;
      } else {
        return 0;
      }
    },
    presentVesselsDisplay: function() {
      return `${this.presentVesselsCount}/${this.activeAuction.bids.length} bids represented`;
    },
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    navbarExpandedOverlay() {
      return this.$store.state.navbarExpandedOverlay;
    },
  },
  async mounted() {},
  watch: {},
};
</script>
<template>
  <div class="row" v-if="auctionId">
    <div style="border-top:1px solid #ced4da;width:100%;margin-left:15px;margin-right:15px;margin-top:0.5rem;margin-bottom:0.5rem;"></div>
    <div :class="[isMobile ? 'col-6' : 'col-4 col-lg-3']">
      <span class="title-text">Lowest Bid<span v-if="activeAuction && activeAuction.includeFuelCost"> (inc. fuel cost)</span></span
      ><br />
      <span class="content-text"
        >{{ lowestBidVessels }}, <span class="lowest-bid">{{ lowestBidRate }} </span></span
      >
    </div>
    <div :class="[isMobile ? 'col-6' : 'col-4 col-lg-3']">
      <span class="title-text">Active Bidders</span><br />
      <span class="content-text"
        >{{ activeBidders }} <i v-if="presentVesselsCount" style="font-size:12px;font-weight:bold;" :class="getRepVesselsClass()">({{ presentVesselsDisplay }})</i></span
      >
    </div>
    <div class="col-4" v-if="isSmallScreen && !isMobile">
      <auction-timer style="float:right"></auction-timer>
    </div>
    <div class="col-12" :class="[activeAuctionStatus != 'Unstarted' ? 'col-lg-5' : 'col-lg-6']">
      <span class="title-text">Actions</span><br />
      <b-button-group class="d-flex button-group" :class="[navbarExpandedOverlay ? 'mobile' : '']">
        <b-button :disabled="activeAuctionStatus != 'In Progress'" class="btn-light" v-on:click="onExtend(30)">Extend (30 sec.)</b-button>
        <b-button :disabled="activeAuctionStatus != 'In Progress'" class="btn-light" v-on:click="onExtend(120)">Extend (2 min.)</b-button>
        <b-button :disabled="activeAuctionStatus == 'Complete'" v-if="auctionTimePassed < 0" class="btn-light" v-on:click="onStartAuctionNowClick()">Start Auction</b-button>
        <b-button :disabled="activeAuctionStatus == 'Complete'" v-else class="btn-light" v-on:click="onEndAuction()">End Auction</b-button>
      </b-button-group>
    </div>
    <div class="col-lg-1" v-if="!isSmallScreen">
      <auction-timer style="float:right"></auction-timer>
    </div>
  </div>
</template>
<style scoped>
.bid-details {
  background-color: #004996;
  color: white;
  padding: 0.5rem;
}
.context-text {
  font-size: 18px;
}
.mobile-layout .content-text {
  font-size: 12px;
}

.lowest-bid {
  color: green;
  font-weight: bold;
}
.not-lowest-bid {
  color: red;
}
.button-group > button:first-child {
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
}
.button-group > button:last-child {
  border-top-right-radius: 999px;
  border-bottom-right-radius: 999px;
}
.button-group.mobile > button {
  font-size: 12px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.all-present {
  color: green;
}
.some-present {
  color: orange;
}
.none-present {
  color: gray;
}
</style>
